import React from "react";
import ModalBox from "../ModalBox/ModalBox";
import WarningIcon from "./WarningIcon/WarningIcon";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import TextLink from "../TextLink/TextLink";
import Loader from "../Loader/Loader";
import "./CancelSubscription.css";

class CancelSubscriptionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };

    this.handleModalOnAccept = this.handleModalOnAccept.bind(this);
  }

  handleModalOnAccept(e) {
    e.preventDefault();
    this.setState(
      {
        isLoading: true,
      },
      () => {
        this.props.handleOnModalAccept();
      }
    );
  }

  render() {
    return (
      <ModalBox
        handleModalOnClose={this.props.handleModalOnClose}
        modalClassName="cancel-subscription-modal"
      >
        {this.state.isLoading ? (
          <Loader />
        ) : (
          <>
            <WarningIcon />
            <h2 className="headline-4">
              Are you sure you want to cancel your subscription?
            </h2>
            <p className="body-text">
              If you click cancel, you cannot go back.
            </p>
            <PrimaryButton
              activatePrimaryWithEnter={true}
              primaryButtonText="Keep my subscription"
              handlePrimaryBtnOnClick={this.props.handleModalOnCancel}
            />
            <TextLink
              to="/"
              text="I am sure, cancel my subscription"
              handleOnClick={this.handleModalOnAccept}
            />
          </>
        )}
      </ModalBox>
    );
  }
}

export default CancelSubscriptionModal;
